import { useState } from 'react'
import { createPortal } from 'react-dom'
import Icon from '../components/Icon'
import { errorText, getLocale } from '../lib/i18n'
import { api } from '../lib/api'

/**
 * Shown on My items after someone says "No thanks" to verifying. Being a non-verified resident is completely fine;
 * the Resident tag is only an idea to help neighbors feel comfortable, and any better idea is welcome right here.
 */
export const SKIP_FLAG = 'vc-res-skip'
const L = (en: string, es: string) => (getLocale() === 'en' ? en : es)

export default function ResidentSkipDialog({ onClose }: { onClose: () => void }) {
  const [idea, setIdea] = useState(''), [busy, setBusy] = useState(false), [sent, setSent] = useState(false), [error, setError] = useState('')
  const send = async () => {
    if (idea.trim().length < 3 || busy) return
    setBusy(true); setError('')
    try { await api('/api/market/feedback', { method: 'POST', body: JSON.stringify({ kind: 'idea', message: `Verifying residents: ${idea.trim()}`.slice(0, 1000), page: location.hash, locale: getLocale() }) }); setSent(true) }
    catch (e) { setError(errorText(e)) } finally { setBusy(false) }
  }
  return createPortal(<div className="fb-layer" role="presentation">
    <div className="fb-sheet" role="dialog" aria-modal="true" aria-labelledby="skip-title">
      <h2 id="skip-title">{L('You are welcome either way', 'Eres bienvenido de todos modos')}</h2>
      <p>{L('You can use Vieques Clasificados fully as a non-verified resident. The Resident tag is just an option we came up with to help neighbors feel more comfortable with each other.', 'Puedes usar Vieques Clasificados completo sin verificar tu residencia. La etiqueta de Residente es solo una opción que se nos ocurrió para que los vecinos se sientan más cómodos entre sí.')}</p>
      {sent ? <p role="status" className="success"><Icon name="check" size={18}/> {L('Thank you. We read every idea.', 'Gracias. Leemos todas las ideas.')}</p> : <>
        <p>{L('Have a better way to do it? We want every idea. Tell us here, or use the Feedback button any time.', '¿Tienes una mejor forma de hacerlo? Queremos todas las ideas. Cuéntanos aquí, o usa el botón de Comentarios cuando quieras.')}</p>
        <label>{L('How would you verify neighbors?', '¿Cómo verificarías a los vecinos?')}
          <textarea rows={3} maxLength={900} value={idea} onChange={e => setIdea(e.target.value)} placeholder={L('Any idea is welcome', 'Cualquier idea es bienvenida')}/>
        </label>
        {error && <p role="alert" className="error">{error}</p>}
      </>}
      <div className="fb-actions">
        {!sent && <button type="button" className="fb-primary" disabled={idea.trim().length < 3 || busy} onClick={() => void send()}>{busy ? '…' : L('Send my idea', 'Enviar mi idea')}</button>}
        <button type="button" onClick={onClose}>{sent ? L('Close', 'Cerrar') : L('No thanks, got it', 'No, gracias, entendido')}</button>
      </div>
    </div>
  </div>, document.body)
}
